



















import { Component, Vue } from "vue-property-decorator";
import MovieContents from "@/components/contact/MovieContents.vue";

@Component({
  components: {
    MovieContents
  }
})
export default class Training extends Vue {}
